export default __webpack_public_path__ + "static/media/nisargadhama.068b8e1c.jpg";